import { axiosAjax } from '@app/src/config/axios';
import { DataListModel } from '@app/src/common/PredictiveInput/DataListModel';
import { hydrateData } from './hydrators';

export const districtService = {
  async get(district: string): Promise<DataListModel[]> {
    try {
      const { data } = await axiosAjax.get(process.env.API_DISTRICT.replace(':districtName', district));
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
